import { render, staticRenderFns } from "./ImagesSlide.vue?vue&type=template&id=1a58e140&scoped=true"
import script from "./ImagesSlide.vue?vue&type=script&lang=js"
export * from "./ImagesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58e140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a58e140')) {
      api.createRecord('1a58e140', component.options)
    } else {
      api.reload('1a58e140', component.options)
    }
    module.hot.accept("./ImagesSlide.vue?vue&type=template&id=1a58e140&scoped=true", function () {
      api.rerender('1a58e140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ImagesSlide.vue"
export default component.exports